(function () {
  if (window.__rxCollectionInit) return;
  window.__rxCollectionInit = true;

  function root(el) { return el.closest('[data-rx-collection]'); }

  function sectionUrl(url, sectionId) {
    var u = new URL(url, window.location.origin);
    u.searchParams.set('section_id', sectionId);
    return u.toString();
  }

  function cleanUrl(url) {
    var u = new URL(url, window.location.origin);
    u.searchParams.delete('section_id');
    return u.pathname + (u.searchParams.toString() ? '?' + u.searchParams.toString() : '');
  }

  function render(r, url, push) {
    var id = r.getAttribute('data-section-id');
    var results = r.querySelector('[data-rx-results]');
    var sideOpen = r.querySelector('.c-side.is-open') !== null;
    if (results) results.classList.add('is-loading');
    return fetch(sectionUrl(url, id), { credentials: 'same-origin' })
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-rx-collection]');
        if (!fresh) { window.location.href = cleanUrl(url); return; }
        r.innerHTML = fresh.innerHTML;
        if (sideOpen) {
          var side = r.querySelector('.c-side');
          var btn = r.querySelector('[data-rx-side-toggle]');
          if (side) side.classList.add('is-open');
          if (btn) btn.setAttribute('aria-expanded', 'true');
        }
        if (push) history.pushState({ rx: true }, '', cleanUrl(url));
      })
      .catch(function () { window.location.href = cleanUrl(url); });
  }

  function formUrl(form) {
    var params = new URLSearchParams(new FormData(form));
    var keep = new URLSearchParams();
    params.forEach(function (v, k) { if (v !== '') keep.append(k, v); });
    var q = keep.toString();
    return form.getAttribute('action') + (q ? '?' + q : '');
  }

  document.addEventListener('change', function (e) {
    var form = e.target.form && e.target.form.matches('[data-rx-filters]') ? e.target.form : null;
    if (!form) return;
    var r = root(form);
    if (!r) return;
    render(r, formUrl(form), true);
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-rx-filters]');
    if (!form || !root(form)) return;
    e.preventDefault();
    render(root(form), formUrl(form), true);
  });

  document.addEventListener('click', function (e) {
    var link = e.target.closest('[data-rx-link]');
    if (link && root(link)) {
      e.preventDefault();
      render(root(link), link.getAttribute('href'), true);
      return;
    }

    var toggle = e.target.closest('[data-rx-side-toggle]');
    if (toggle && root(toggle)) {
      var side = root(toggle).querySelector('.c-side');
      var open = !side.classList.contains('is-open');
      side.classList.toggle('is-open', open);
      root(toggle).querySelectorAll('[data-rx-side-toggle]').forEach(function (t) { t.setAttribute('aria-expanded', open ? 'true' : 'false'); });
      document.documentElement.classList.toggle('rx-filters-open', open && window.matchMedia('(max-width: 860px)').matches);
      if (open) { var x = side.querySelector('.c-side__close'); if (x && window.matchMedia('(max-width: 860px)').matches) x.focus(); }
      return;
    }

    var more = e.target.closest('[data-rx-load-more]');
    if (more && root(more)) {
      e.preventDefault();
      var r = root(more);
      var id = r.getAttribute('data-section-id');
      more.setAttribute('aria-busy', 'true');
      more.textContent = 'Loading…';
      fetch(sectionUrl(more.getAttribute('href'), id), { credentials: 'same-origin' })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var grid = r.querySelector('[data-rx-grid]');
          var newGrid = doc.querySelector('[data-rx-grid]');
          var firstNew = null;
          if (grid && newGrid) {
            Array.prototype.slice.call(newGrid.children).forEach(function (child) {
              var node = document.importNode(child, true);
              if (!firstNew) firstNew = node;
              grid.appendChild(node);
            });
          }
          var footer = r.querySelector('[data-rx-more]');
          var newFooter = doc.querySelector('[data-rx-more]');
          if (footer && newFooter) footer.innerHTML = newFooter.innerHTML;
          var link = firstNew && firstNew.querySelector('a.rx-card__title');
          if (link) link.focus({ preventScroll: true });
        })
        .catch(function () { window.location.href = more.getAttribute('href'); });
    }
  });

  window.addEventListener('popstate', function () {
    var r = document.querySelector('[data-rx-collection]');
    if (r) render(r, window.location.href, false);
  });
})();

// Escape closes the mobile filter panel.
document.addEventListener('keydown', function (e) {
  if (e.key !== 'Escape' || !document.documentElement.classList.contains('rx-filters-open')) return;
  var x = document.querySelector('.c-side.is-open .c-side__close');
  if (x) x.click();
});

